var _excluded = ["logo", "navigation", "cart", "backLink", "searchInput", "mobileNavigationBackLinkText", "wrapperRef", "barRef", "onHeaderLoad", "onHeaderVisibilityChange", "hamburgerOnClick", "isDarkMode", "hasHideBoxShadow", "hasBottomBar", "isHeaderSticky", "setIsHeaderSticky", "setIsBottomBarSticky"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useCallback, useContext, useEffect, useReducer, useRef, useState } from "react";
import BrandContext from "../../../../../contexts/BrandContext";
import { useGlobalFontSizeContext } from "../../../../../contexts/GlobalFontSizeContext";
import OnColorContext from "../../../../../contexts/OnColorContext";
import PreventPageScroll from "../../../../../helpers/PreventPageScroll";
import useBreakpoint from "../../../../../hooks/useBreakpoint";
import useLargeZoom from "../../../../../hooks/useLargeZoom";
import Picture from "../../../../quarks/Picture";
import BreakpointVisibilityOrg from "../../../BreakpointVisibilityOrg";
import DispatchContext from "../../contexts/DispatchContext";
import StateContext from "../../contexts/StateContext";
import mainReducer, { ActionType, initialState } from "../../reducers/mainReducer";
import { hugeBreakpointValue } from "../settings";
import CartButtonAtm from "./CartButtonAtm";
import { BackLink, Divider, Hamburger, InputContainer, Main, MobileAside, Navigation, StyledInputMol, BackLinkWrapper, StyledLink } from "./MainOrg.styled";
function MainOrg(_ref) {
  var logo = _ref.logo,
    navigation = _ref.navigation,
    cart = _ref.cart,
    backLink = _ref.backLink,
    searchInput = _ref.searchInput,
    mobileNavigationBackLinkText = _ref.mobileNavigationBackLinkText,
    wrapperRef = _ref.wrapperRef,
    barRef = _ref.barRef,
    onHeaderLoad = _ref.onHeaderLoad,
    onHeaderVisibilityChange = _ref.onHeaderVisibilityChange,
    hamburgerOnClick = _ref.hamburgerOnClick,
    isDarkMode = _ref.isDarkMode,
    hasHideBoxShadow = _ref.hasHideBoxShadow,
    hasBottomBar = _ref.hasBottomBar,
    isHeaderSticky = _ref.isHeaderSticky,
    setIsHeaderSticky = _ref.setIsHeaderSticky,
    setIsBottomBarSticky = _ref.setIsBottomBarSticky,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var brand = useContext(BrandContext);
  var onColor = useContext(OnColorContext);
  var isLargeZoom = useLargeZoom();
  var _useReducer = useReducer(mainReducer, initialState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var navigationIndex = state.navigationIndex,
    isNavigationActive = state.isNavigationActive;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    scrollLastPosition = _useState2[0],
    setScrollLastPosition = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    scrollDelta = _useState4[0],
    setScrollDelta = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    windowHeight = _useState6[0],
    setWindowHeight = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    hasEnabledStickiness = _useState8[0],
    setHasEnabledStickiness = _useState8[1];
  var isHugeScreenBreakpoint = useBreakpoint(hugeBreakpointValue);
  var isHugeScreen = isHugeScreenBreakpoint && !state.isMobileNavigationOnDesktop;
  var hasCart = !!cart && Object.keys(cart).length !== 0;
  var mainElementRef = useRef(null);
  var fontSize = useGlobalFontSizeContext();
  var handleLogoClick = function handleLogoClick(onClick) {
    return function (event) {
      dispatch({
        type: ActionType.SET_NAVIGATION_INACTIVE
      });
      if (onClick) {
        onClick(event);
      }
    };
  };
  var handleHamburgerClick = function handleHamburgerClick() {
    if (isNavigationActive) {
      dispatch({
        type: ActionType.SET_NAVIGATION_INACTIVE
      });
    } else {
      dispatch({
        type: ActionType.SET_NAVIGATION_ACTIVE,
        navigationIndex: null,
        markerLeftPosition: null,
        desktopDropdown: null
      });
      if (hamburgerOnClick) {
        hamburgerOnClick();
      }
    }
  };
  var handleBackLinkClick = function handleBackLinkClick() {
    dispatch({
      type: ActionType.SET_NAVIGATION_ACTIVE,
      navigationIndex: null,
      markerLeftPosition: null,
      desktopDropdown: null
    });
  };
  var getScrollSpeed = useCallback(function () {
    var newPosition = window.scrollY;
    if (scrollLastPosition != null) {
      setScrollDelta(newPosition - scrollLastPosition);
    }
    setScrollLastPosition(newPosition);
    return scrollDelta;
  }, [scrollLastPosition, scrollDelta]);
  var getWindowHeight = function getWindowHeight() {
    return window.innerHeight;
  };
  var handleWindowScroll = useCallback(function () {
    var wrapper = wrapperRef.current;
    var wrapperHeight = wrapper ? wrapper.offsetHeight : 0;
    var wrapperOffsetTop = wrapper ? wrapper.offsetTop : 0;
    var wrapperBreakpoint = wrapperHeight + wrapperOffsetTop;
    var bar = barRef.current;
    var barHeight = bar ? bar.offsetHeight : 0;
    var barBreakpoint = barHeight + wrapperOffsetTop;
    var mainHeight = wrapperHeight - barHeight;
    var scrollSpeed = getScrollSpeed();
    var scrollSpeedValue = isHugeScreen ? -75 : -1;
    if (!isLargeZoom && (window.scrollY > wrapperBreakpoint || isNavigationActive && window.scrollY > barBreakpoint)) {
      setHasEnabledStickiness(true);
      setIsBottomBarSticky(true);
    } else {
      setHasEnabledStickiness(false);
      setIsHeaderSticky(false);
      setIsBottomBarSticky(false);
      return;
    }
    if (!isLargeZoom && scrollSpeed <= scrollSpeedValue || scrollSpeed <= 0 && isHeaderSticky || isNavigationActive) {
      setIsHeaderSticky(true);
      if (onHeaderVisibilityChange) {
        onHeaderVisibilityChange(true, mainHeight);
      }
    } else {
      setIsHeaderSticky(false);
      if (onHeaderVisibilityChange) {
        onHeaderVisibilityChange(false, mainHeight);
      }
    }
  }, [wrapperRef, barRef, getScrollSpeed, isHugeScreen, isNavigationActive, isHeaderSticky, onHeaderVisibilityChange]);
  var handleHeaderIsTooWide = function handleHeaderIsTooWide() {
    var _mainElementRef$curre, _mainElementRef$curre2;
    if (!mainElementRef.current) return;
    var mainElementWidth = mainElementRef.current.scrollWidth;
    var maxWidth = (_mainElementRef$curre = (_mainElementRef$curre2 = mainElementRef.current.parentElement) === null || _mainElementRef$curre2 === void 0 ? void 0 : _mainElementRef$curre2.clientWidth) !== null && _mainElementRef$curre !== void 0 ? _mainElementRef$curre : 0;
    var computedStyle = getComputedStyle(mainElementRef.current);
    var borderToleranceSpace = 2;
    var rightBorder = parseInt(computedStyle.borderRightWidth, 10) - borderToleranceSpace;
    if (mainElementWidth + rightBorder > maxWidth) {
      dispatch({
        type: ActionType.SET_IS_MOBILE_NAVIGATION_ON_DESKTOP,
        isMobileNavigationOnDesktop: true
      });
    }
  };
  var handleWindowResize = useCallback(function () {
    setWindowHeight(getWindowHeight());
  }, []);
  useEffect(function () {
    window.addEventListener("scroll", handleWindowScroll);
    return function () {
      window.removeEventListener("scroll", handleWindowScroll);
    };
  }, [handleWindowScroll]);
  useEffect(function () {
    handleWindowResize();
    window.addEventListener("resize", handleWindowResize);
    window.addEventListener("resize", handleHeaderIsTooWide);
    return function () {
      window.removeEventListener("resize", handleWindowResize);
      window.removeEventListener("resize", handleHeaderIsTooWide);
    };
  }, [handleWindowResize]);
  useEffect(function () {
    if (fontSize) {
      if (state.isMobileNavigationOnDesktop) {
        dispatch({
          type: ActionType.SET_IS_MOBILE_NAVIGATION_ON_DESKTOP,
          isMobileNavigationOnDesktop: false
        });
      }
      handleHeaderIsTooWide();
    }
  }, [fontSize]);
  useEffect(function () {
    dispatch({
      type: ActionType.SET_NAVIGATION_INACTIVE
    });
  }, [isHugeScreen]);
  useEffect(function () {
    if (onHeaderLoad) {
      var wrapper = wrapperRef.current;
      var wrapperHeight = wrapper ? wrapper.offsetHeight : 0;
      onHeaderLoad(wrapperHeight);
    }
  }, []);
  var navigationComponent = /*#__PURE__*/React.createElement(Navigation, {
    navigation: navigation,
    backLink: backLink,
    $windowHeight: windowHeight,
    $isNavigationActive: isNavigationActive,
    $hasCart: hasCart,
    $isMobileNavigationOnDesktop: state.isMobileNavigationOnDesktop
  });
  var showSearchInput = searchInput && hasEnabledStickiness && !isHugeScreen && !isNavigationActive;
  var cartComponent = hasCart && /*#__PURE__*/React.createElement(CartButtonAtm, _extends({}, cart, {
    "data-test-id": "basket-link"
  }));
  var menuMainJSX = showSearchInput ? /*#__PURE__*/React.createElement(InputContainer, null, /*#__PURE__*/React.createElement(StyledInputMol, _extends({
    size: "small",
    hasHiddenBorder: true
  }, searchInput)), /*#__PURE__*/React.createElement(Divider, {
    $brand: brand,
    onColor: onColor
  })) : /*#__PURE__*/React.createElement(StyledLink, {
    href: logo.href,
    to: logo.to,
    title: logo.title,
    onClick: handleLogoClick(logo.onClick),
    "data-test-id": "brand-link"
  }, /*#__PURE__*/React.createElement(Picture, {
    srcData: logo,
    hasLazyLoading: false
  }));
  var mainContentJSX = /*#__PURE__*/React.createElement(React.Fragment, null, state.isMobileNavigationOnDesktop ? null : /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "huge"
  }, menuMainJSX), /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "small",
    to: state.isMobileNavigationOnDesktop ? undefined : "huge"
  }, isNavigationActive && navigationIndex !== null ? /*#__PURE__*/React.createElement(BackLink, {
    text: mobileNavigationBackLinkText,
    onClick: handleBackLinkClick
  }) : menuMainJSX), /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "small",
    to: state.isMobileNavigationOnDesktop ? undefined : "huge"
  }, /*#__PURE__*/React.createElement(MobileAside, {
    $showSearchInput: !!showSearchInput
  }, !isNavigationActive && cartComponent, /*#__PURE__*/React.createElement(Hamburger, {
    isActive: isNavigationActive,
    onClick: handleHamburgerClick
  }))), navigationComponent, cartComponent && !state.isMobileNavigationOnDesktop ? /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "huge"
  }, cartComponent) : null, backLink ? /*#__PURE__*/React.createElement(BackLinkWrapper, {
    $isMobileNavigationOnDesktop: state.isMobileNavigationOnDesktop
  }, backLink) : null);
  return /*#__PURE__*/React.createElement(StateContext.Provider, {
    value: state
  }, /*#__PURE__*/React.createElement(DispatchContext.Provider, {
    value: dispatch
  }, !isHugeScreen && isNavigationActive ? /*#__PURE__*/React.createElement(PreventPageScroll, null) : null, /*#__PURE__*/React.createElement(Main, _extends({
    id: "pageHeaderMain",
    ref: mainElementRef,
    $hasEnabledStickiness: hasEnabledStickiness,
    $couldBeSticky: isHeaderSticky,
    $isNavigationActive: isNavigationActive,
    $hasCart: hasCart,
    $background: onColor,
    $isDarkMode: isDarkMode,
    $hasHideBoxShadow: hasHideBoxShadow,
    $hasBottomBar: hasBottomBar,
    $isMobileNavigationOnDesktop: state.isMobileNavigationOnDesktop
  }, restProps), mainContentJSX)));
}
export default MainOrg;